import { CountryMiniData } from './country';
import { AdminMiniData, Error, UserAccountStatus, UserPinStatus } from './data';
import { UserBankAccountData } from './UserBankAccount';
import { UserCompanyDetailsData } from './UserCompanyDetails';
import { UsersComplianceDetailsData } from './UserCompliance';
import { UserContactPersonData } from './UserContactPerson';
import { UserDocumentData } from './UserDocument';
import { UserInternationalBData } from './UserInternationalB';
import { UserKycValidate } from './UserKycValidate';
import { UserLocalBranchData } from './UserLocalBranch';
import { UserOwnerData } from './UserOwner';
import { UserRelatedEntityData } from './UserRelatedEntity';
import { UsersDirectorDetailsData } from './UsersDirectorDetails';
import { UserTransactionDetailsData } from './UserTransactionDetails';

export class UserTokenCheck {
  success: true|false;
  error: Error;
  results: string;
  token: {token: string, refresh: string};
}

export class OneUser {
    success: true|false;
    error: Error;
    results: string;
    data: UserData;
}

export class UserData {
    ref: number;
    lastName: string;
    firstName: string;
    phone: string;
    email: string;
    country: CountryMiniData;
    status: UserAccountStatus;
    pinStatus: UserPinStatus;
    companyDetails: UserCompanyDetailsData;
    transaction: UserTransactionDetailsData;
    compliance: UsersComplianceDetailsData;
    directorDetails: UsersDirectorDetailsData[] = [];
    contactPersons: UserContactPersonData[] = [];
    ownership: UserOwnerData[] = [];
    localSubsidiary: UserLocalBranchData[] = [];
    intSubsidiary: UserInternationalBData[] = [];
    relatedEntity: UserRelatedEntityData[] = [];
    bankAccounts: UserBankAccountData[] = [];
    documents: UserDocumentData[] = [];
    validation: UserKycValidate;
    createdBy: AdminMiniData;
    lastModifiedBy: AdminMiniData;
    userSettings: UserSettings;
    created: string;
    lastModified: string;

    constructor() {
        this.country = new CountryMiniData();
        this.companyDetails = new UserCompanyDetailsData();
        this.status = new UserAccountStatus();
        this.pinStatus = new UserPinStatus();
        this.createdBy = new AdminMiniData();
        this.lastModifiedBy = new AdminMiniData();
        this.validation = new UserKycValidate();
        this.userSettings = new UserSettings();
    }
}

export class UserSettings {
    identityDocument: string[];
}